import React, {useEffect, useState} from 'react';
import './wpl-multi-select.css'
import check from '../../assets/img/done-24px.svg'
import arrow from '../../assets/img/arr_down.png'


export default function WplMultiSelect({
                                           title, options, selected, onSelected, singleSelect = false, openUp = false,
                                           className, closeOnSelect = false
                                       }) {
    const [open, setOpen] = useState(false);
    const [uniqueOptions, setUniqueOptions] = useState([]);

    function getTitle() {
        if (singleSelect) {
            return selected ? selected : title;
        }
        if (selected.length === 0) return title;
        if (selected.length <= 2) return selected.join(', ');
        return `${selected[0]} (+${selected.length - 1} other${selected.length > 2 ? 's' : ''})`
    }

    useEffect(() => {
        const opts = options.filter((o, idx) => o && options.indexOf(o) === idx)
        setUniqueOptions(opts)
    }, [options])

    return (<div tabIndex='0' className={`wpl-multi-select ${className}`} onBlur={() => setOpen(false)}>
        <div className={`option-wrapper ${open ? 'open' : 'closed'} ${openUp ? 'open-up' : ''}`}>
            {uniqueOptions.map((o, idx) =>
                <div key={idx}
                     onClick={() => onSelected(o) || (closeOnSelect && setOpen(false))}
                     className={`option ${selected.indexOf(o) !== -1 && 'selected'}`}>
                    <img src={check} alt='check'/>
                    <span>{o}</span>
                </div>
            )}
        </div>
        <div className='title' onClick={() => setOpen(!open)}>
            <span className='multiselect-option'>{getTitle()}</span>
            <img src={arrow} alt='open'/>
        </div>
    </div>)
}
